<template>
  <div class="md-layout" style="height: 60vh">
    <div class="md-layout-item md-size-100">
      <time-line plain :type="simpleTimeline">
        <time-line-item :inverted="item.inverted" badge-type="success" badge-icon="extension" :key="item.time" v-for="item in histories" :class="{ 'timeline-inverted': responsive }">
          <badge slot="header" type="danger">{{ item.time | formatDateTime }}</badge>
          <div slot="content">
            <ul>
              <li>
                {{ $t("shippingPlan.modifiedBy") }}:
                <img v-if="buildAvatarLink(item.modifiedById)" :src="buildAvatarLink(item.modifiedById)" style="display: inline-block; width: 50px; margin-right: 5px" />
                <strong>{{ item.modifiedBy }}</strong>
              </li>
              <li :key="c.item1" v-for="c in item.valuesChanged.filter((i) => shouldNotDisplayProeprties(i.item1))">
                {{ $t("shippingPlan.changed") }} <strong>{{ getPropertyText(c.item1) }}</strong> from <strong>{{ c.item3 || "N/A" }}</strong> to
                <strong> {{ c.item2 || "N/A" }}</strong>
              </li>
            </ul>
            {{ item.content }}
          </div>
        </time-line-item>
      </time-line>
    </div>
  </div>
</template>
<script>
// import PerfectScrollbar from "perfect-scrollbar";
import { TimeLine, TimeLineItem, Badge } from "@/components";
import config from "../../config";

export default {
  name: "Historical2",
  components: {
    TimeLine,
    TimeLineItem,
    Badge,
  },
  props: {
    shipmentRecordId: {
      type: Number,
    },
  },
  data() {
    return {
      responsive: false,
    };
  },
  computed: {
    simpleTimeline() {
      if (this.responsive) {
        return "simple";
      }
      return "";
    },
    histories() {
      return this.$store.state.shippingPlans.histories || [];
    },
    historyAvatars() {
      return this.$store.state.shippingPlans.historyAvatars || {};
    },
  },
  methods: {
    buildAvatarLink(userId) {
      const key = `${userId}`;
      return this.historyAvatars[key] && this.historyAvatars[key];
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    getPropertyText(propertyName) {
      return propertyName;
    },
    shouldNotDisplayProeprties(propertyName) {
      const excludes = [
        "Documents",
        "RecordStatusId",
        "RecordStatusColor",
        "RecordTagId",
        "RecordTagColor",
        "LinkedProductId",
        "ContainerSizeId",
        "ContainerArrivalPlaceId",
        "CarrierNameId",
        "PaymentStatusId",
        "ShipmentPaidStatusId",
        "CustomsPaidStatusId",
        "ChinaStatusId",
        "ModifiedOn",
        "AuditEndTime",
        "AuditStartTime",
      ];
      return !excludes.includes(propertyName);
    },
  },
  created() {
    Promise.all([
      this.$store.dispatch("shippingPlans/getShippingPlan", { shipmentRecordId: this.shipmentRecordId }),
      this.$store.dispatch("shippingPlans/getHistoricalShippingPlan", { shipmentRecordId: this.shipmentRecordId }),
    ]).finally(() => {});
  },
  mounted() {
    // new PerfectScrollbar(`.historical-modal-container .md-layout-item`);
  },
  beforeDestroy() {},
};
</script>
<style></style>
